export default __webpack_public_path__ + "static/media/CITROEN.c7764d4b.png";